import Request from './request';

export default class ContactHttpService {
    private static uri = 'contacts';

    public static readMany(params: {
        skip?: number;
        take?: number;
        term?: string;
    }) {
        return Request.get(`${this.uri}`, params);
    }
}
